export default __webpack_public_path__ + "static/media/logo.cf60348f.svg";